export default function (other) {
  other = other || {}
  return {
    title: other.title || null,
    description: other.description || null,
    type: other.type || 'GENERAL',
    status: other.status || null,
    priority: other.priority || 'MEDIUM',
    assigneeUserId: other.assigneeUserId || null,
    watchers: other.watchers || [],
    dueDate: other.dueDate || null,
    relatedModule: other.relatedModule || null,
    relatedId: other.relatedId || null,
    context: other.context || null,
  }
}
